import { useEffect, useState } from 'react';
import { maintenanceCheck } from "./auth/authApi";
import apiCall from './auth/apiCall';

function MaintenanceMode() {

  // Define variables
  const [maintenanceMode, setMaintenanceMode] = useState(false);


  // Component load
  useEffect(() => {
    apiCall(maintenanceCheck).then((response) => {
      if( response.success && response.data ) {
        setMaintenanceMode(true);
      }
    });
  }, []);


  // Screen elements
  let element;
  if( maintenanceMode ) {
    element = (
      <div id='maintenance_mode' class='flex-column'>
        <div class='flex-column'>
          <h3>We'll Be Back Soon</h3>
          <p>We're currently undergoing system maintenance to improve your experience.</p>
          <p>We'll be back online in less than an hour.</p>
        </div>
      </div>
    );
  }

  return (
    <>{element}</>
  );
}

export default MaintenanceMode;